/** Whether the user currently has any MFA method active in Cognito */
export function isMfaEnabledForCognitoUser(u) {
    var _a;
    if (!u)
        return false;
    if ((_a = u.userMFASettingList) === null || _a === void 0 ? void 0 : _a.length)
        return true;
    if (u.preferredMfaSetting)
        return true;
    return Array.isArray(u.mfaOptions) && u.mfaOptions.length > 0; // legacy SMS
}
